<!-- <div class="code-review-list">
    <div class="header">
        <button mat-button color="primary" (click)="openAddCodeReviewDialog()" style="float: right;">
          Add Code Review
        </button>
    </div>
    <ul>
      <li *ngFor="let codeReview of codeReviews">
        <a [routerLink]="['/code-link-review', codeReview._id]" class="title">
          {{ codeReview.title }}
        </a>
        <div class="tagline">
          <span>Created by: {{ codeReview.created_by }}</span> | 
          <span>Created on: {{ codeReview?.created_time | date:'MMM d, yyyy, h:mm:ss a' }}</span> |
          <span>{{ codeReview.state }}</span>
        </div>
      </li>
    </ul>

    <ze-pagination *ngIf="paginationPage && totalPages > 1" [pageDetails]="paginationPage"
        (gotoPage)="onChangePage($event)"></ze-pagination>
</div> -->


<div class="codeReview_header">
  <ul>
    <!-- <li><svg aria-hidden="true" height="16" viewBox="0 0 16 16" version="1.1" width="16" data-view-component="true"
        class="octicon octicon-code UnderlineNav-octicon d-none d-sm-inline">
        <path
          d="m11.28 3.22 4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734L13.94 8l-3.72-3.72a.749.749 0 0 1 .326-1.275.749.749 0 0 1 .734.215Zm-6.56 0a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042L2.06 8l3.72 3.72a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L.47 8.53a.75.75 0 0 1 0-1.06Z">
        </path>
      </svg> Code</li> -->
    <li><svg aria-hidden="true" height="16" viewBox="0 0 16 16" version="1.1" width="16" data-view-component="true"
        class="octicon octicon-git-pull-request UnderlineNav-octicon d-none d-sm-inline">
        <path
          d="M1.5 3.25a2.25 2.25 0 1 1 3 2.122v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.25 2.25 0 0 1 1.5 3.25Zm5.677-.177L9.573.677A.25.25 0 0 1 10 .854V2.5h1A2.5 2.5 0 0 1 13.5 5v5.628a2.251 2.251 0 1 1-1.5 0V5a1 1 0 0 0-1-1h-1v1.646a.25.25 0 0 1-.427.177L7.177 3.427a.25.25 0 0 1 0-.354ZM3.75 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm0 9.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm8.25.75a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0Z">
        </path>
      </svg>Code review list</li>
  </ul>

</div>
<div class="codeReview_content">
  <div class="codeReview_centent_top">
    <div class="content_top_top">
      <div class="top_left">
        <div>
          <!-- <select>
              <option>1</option>
              <option>1</option>
              <option>1</option>
            </select> -->
          <!-- <input placeholder="Search"> -->
        </div>
      </div>
      <div class="top_middle">
        <!-- top_middl -->
      </div>
      <div class="top_right">
        <button (click)="openAddCodeReviewDialog()" [featureActionState]="'CODE_REVIEW'">New code review</button>
      </div>
    </div>

  </div>
  <div class="codeReview_content_bottom">
    <ul>
      <!-- <li>
          <div class="bottom_left">
            bottom_left
          </div>
          <div class="bottom_middle">
            bottom_middle
          </div>
          <div class="bottom_right">
            bottom_right
          </div>
        </li> -->
      <!-- <li>
        <div class="bottom_left">
          <div><input type="checkbox"></div>
        </div>
        <div class="bottom_middle">
          <div class="bottom_middle_heading">
            <div><svg aria-hidden="true" height="16" viewBox="0 0 16 16" version="1.1" width="16"
                data-view-component="true"
                class="octicon octicon-git-pull-request UnderlineNav-octicon d-none d-sm-inline">
                <path
                  d="M1.5 3.25a2.25 2.25 0 1 1 3 2.122v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.25 2.25 0 0 1 1.5 3.25Zm5.677-.177L9.573.677A.25.25 0 0 1 10 .854V2.5h1A2.5 2.5 0 0 1 13.5 5v5.628a2.251 2.251 0 1 1-1.5 0V5a1 1 0 0 0-1-1h-1v1.646a.25.25 0 0 1-.427.177L7.177 3.427a.25.25 0 0 1 0-.354ZM3.75 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm0 9.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm8.25.75a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0Z">
                </path>
              </svg></div>
            <p>2 Open</p>
          </div>
          <div>
            <svg aria-hidden="true" height="16" viewBox="0 0 16 16" version="1.1" width="16" data-view-component="true"
              class="octicon octicon-check">
              <path
                d="M13.78 4.22a.75.75 0 0 1 0 1.06l-7.25 7.25a.75.75 0 0 1-1.06 0L2.22 9.28a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018L6 10.94l6.72-6.72a.75.75 0 0 1 1.06 0Z">
              </path>
            </svg> 46 Closed
          </div>

        </div>
        <div class="bottom_right">
          <ul class="option">
            <li>Test</li>
            <li>Test</li>
            <li>Test</li>
            <li>Test</li>
            <li>Test</li>
          </ul>
        </div>
      </li> -->
      <!-- for loop -->

      <li class="hover" *ngFor="let codeReview of codeReviews; let i = index"
        [ngClass]="{'green-bg': i % 2 === 0, 'pink-bg': i % 2 === 1}">
        <div class="bottom_left">
          <mat-checkbox class="check-box custom-checkbox"></mat-checkbox>
          <!-- <div><input type="checkbox"></div> -->
        </div>
        <div class="bottom_middle">
          <div class="bottom_middle_heading">
            <div class="title_svg">
              <div class="code-review-opened-svg">
                <svg *ngIf="codeReview.state=='OPENED'" aria-hidden="true" height="16" viewBox="0 0 16 16" version="1.1" width="16"
                data-view-component="true"
                class="octicon octicon-git-pull-request UnderlineNav-octicon d-none d-sm-inline">
                <path
                  d="M1.5 3.25a2.25 2.25 0 1 1 3 2.122v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.25 2.25 0 0 1 1.5 3.25Zm5.677-.177L9.573.677A.25.25 0 0 1 10 .854V2.5h1A2.5 2.5 0 0 1 13.5 5v5.628a2.251 2.251 0 1 1-1.5 0V5a1 1 0 0 0-1-1h-1v1.646a.25.25 0 0 1-.427.177L7.177 3.427a.25.25 0 0 1 0-.354ZM3.75 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm0 9.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm8.25.75a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0Z">
                </path>
              </svg>
              </div>
              <div class="code-review-closed-svg">
                <svg *ngIf="codeReview.state=='CLOSED'" aria-hidden="true" height="16" viewBox="0 0 16 16" version="1.1" width="16" 
                  data-view-component="true" 
                  class="octicon octicon-git-pull-request-closed closed">
                  <path d="M3.25 1A2.25 2.25 0 0 1 4 5.372v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.251 2.251 0 0 1 3.25 1Zm9.5 5.5a.75.75 0 0 1 .75.75v3.378a2.251 2.251 0 1 1-1.5 0V7.25a.75.75 0 0 1 .75-.75Zm-2.03-5.273a.75.75 0 0 1 1.06 0l.97.97.97-.97a.748.748 0 0 1 1.265.332.75.75 0 0 1-.205.729l-.97.97.97.97a.751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018l-.97-.97-.97.97a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l.97-.97-.97-.97a.75.75 0 0 1 0-1.06ZM2.5 3.25a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0ZM3.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm9.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z"></path>
                </svg>
              </div>
              <div class="code-review-merged-svg">
                <svg *ngIf="codeReview.state=='MERGED'" class="octicon octicon-git-merge color-fg-done" viewBox="0 0 16 16" version="1.1" width="16" height="16" aria-hidden="true">
                  <path d="M5.45 5.154A4.25 4.25 0 0 0 9.25 7.5h1.378a2.251 2.251 0 1 1 0 1.5H9.25A5.734 5.734 0 0 1 5 7.123v3.505a2.25 2.25 0 1 1-1.5 0V5.372a2.25 2.25 0 1 1 1.95-.218ZM4.25 13.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm8.5-4.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM5 3.25a.75.75 0 1 0 0 .005V3.25Z"></path>
                </svg>
              </div>
            </div>
            <a class="title" [routerLink]="['/code-link-review', codeReview._id.$oid ? codeReview._id.$oid : codeReview._id]">{{ codeReview.title }}</a>
          </div>
          <p class="small"><span># Created by: {{ codeReview.created_by }}</span> |
            <span>Created on: {{ codeReview?.created_time | date:'MMM d, yyyy, h:mm:ss a' }}</span> |
            <span>{{ codeReview.state | titlecase }}</span> |
            <span>( {{ codeReview.artifact_type | titlecase }} : {{ codeReview.artifact_name }} )</span>
          </p>
        </div>
        <div class="bottom_right">
          <svg aria-hidden="true" height="16" viewBox="0 0 16 16" version="1.1" width="16" data-view-component="true"
            class="octicon octicon-comment v-align-middle">
            <path
              d="M1 2.75C1 1.784 1.784 1 2.75 1h10.5c.966 0 1.75.784 1.75 1.75v7.5A1.75 1.75 0 0 1 13.25 12H9.06l-2.573 2.573A1.458 1.458 0 0 1 4 13.543V12H2.75A1.75 1.75 0 0 1 1 10.25Zm1.75-.25a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.19l2.72-2.72a.749.749 0 0 1 .53-.22h4.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25Z">
            </path>
          </svg>&nbsp;&nbsp;2
        </div>
      </li>
    </ul>
    <ze-pagination *ngIf="paginationPage && totalPages > 1" [pageDetails]="paginationPage"
      (gotoPage)="onChangePage($event)"></ze-pagination>
  </div>
</div>
